import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { RenderField, Validators } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as UserModule from './../../../Modules/UserModule';
import * as ViewManagementModule from './../../../Modules/ViewManagementModule';

type ConnectedProps = {
    userStore: UserModule.Types.UserStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
};
type Props = {
    onClose: Function;
    onDelete: () => void;
    currentAddress: string;
};
const AddPoiForm = (props: InjectedFormProps & ConnectedProps & Props) => {
    const { handleSubmit, pristine, submitting, t } = props;
    return (
        <div className="poipreview">
            <div className="poipreview__title">
                <h5>{t('addPOI')}</h5>
            </div>
            <form className="form" onSubmit={handleSubmit}>
                <Field name="address" component={RenderField} type="text" disabled placeholder={t('pickAddress')} label={t('address')} validate={[Validators.required]} />
                <Field name="title" component={RenderField} type="text" placeholder={t('poiName')} label={t('poiName')} validate={[Validators.required]} />
                <Field name="radiusMeters" component={RenderField} min={0} max={2000} type="range" placeholder={t('poiRange')} label={t('poiRange')} validate={[Validators.required]} />
                <div className="poiForm__buttons">
                    <div className="poiForm__button-delete" onClick={() => props.onClose()}>
                        <span className="btn btn--clean">{t('cancel')}</span>
                    </div>
                    {props.initialValues['id'] && (
                        <div className="poiForm__button-delete" onClick={async () => props.onDelete()}>
                            <img width="30" src={'/images/icons/garbage.svg'} />
                            <span className="btn btn--clean"> {t('delete')}</span>
                        </div>
                    )}
                    <button disabled={submitting || pristine} className="btn btn--blue" type="submit">
                        {props.initialValues['id'] ? t('update') : t('add')}
                    </button>
                </div>
            </form>
        </div>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore
    };
}

const temp0 = connect(mapStateToProps)(AddPoiForm)

const temp1 = reduxForm({
    form: 'addPoiForm',
    enableReinitialize: true
})(temp0)

export default withTranslation (['forms', 'errors'])(
     temp1 as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/Form/AddPoiForm.tsx